import { render, staticRenderFns } from "./CircularProgressBarWidget.vue?vue&type=template&id=2da8a4bc&scoped=true"
import script from "./CircularProgressBarWidget.vue?vue&type=script&lang=ts"
export * from "./CircularProgressBarWidget.vue?vue&type=script&lang=ts"
import style0 from "./CircularProgressBarWidget.vue?vue&type=style&index=0&id=2da8a4bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da8a4bc",
  null
  
)

export default component.exports